module.exports = __webpack_public_path__ + "static/media/angrycat.493c5785.gif";